/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReport } from '../../models/construction-day-report';

export interface ApiV0BinaryAnalyzeConstructionDayReportAudioPost$Plain$Params {
  CompanyId?: string;
      body?: {
'File'?: Blob;
}
}

export function apiV0BinaryAnalyzeConstructionDayReportAudioPost$Plain(http: HttpClient, rootUrl: string, params?: ApiV0BinaryAnalyzeConstructionDayReportAudioPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ConstructionDayReport>> {
  const rb = new RequestBuilder(rootUrl, apiV0BinaryAnalyzeConstructionDayReportAudioPost$Plain.PATH, 'post');
  if (params) {
    rb.query('CompanyId', params.CompanyId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConstructionDayReport>;
    })
  );
}

apiV0BinaryAnalyzeConstructionDayReportAudioPost$Plain.PATH = '/api/v0/binary/analyze-construction-day-report-audio';
